module.exports = __webpack_public_path__ + "static/media/header.60598f6d.jpg";